<template>
    <div>
        <div class="header-tool">
            <input @input="handleSearchInput" class="form-control search-input" />
            <el-button size="mini" @click.native="download"><i class="glyphicon glyphicon-download-alt"></i></el-button>
        </div>
        <t-table
            id="mainTable"
            :data="tableData.data"
            :pageSize="queryTableParams.pageSize"
            :curPage="queryTableParams.pageNum"
            :total="tableData.total"
            @current-change="handleTableCurrentChange"
            @sort-change="handleSortable"
            @size-change="handleTablePageSize"
        >
            <t-table-column label="Gene Symbol" property="geneSymbol" width="4%" sortable />
            <t-table-column label="Ensembl ID" property="ensg" width="8%" sortable />
            <t-table-column label="Gene Type" property="geneBiotype" width="8%" sortable/>
            <t-table-column label="CHR" property="chr" width="4%" sortable>
                <template slot-scope="{ row }">
                    <span>{{ 'chr' + row.chr }}</span>
                </template>
            </t-table-column>
            <t-table-column label="Location" property="location" width="10%" sortable >
                <template slot-scope="{ row }">
                    <span>{{ 'chr' + row.chr + ':' + row.start + '-' + row.end }}</span>
                </template>
            </t-table-column>
            <t-table-column label="Reported Trait" property="reportedTrait" width="16%" sortable />
            <t-table-column label="Trait Label" property="efoOntologyTrait" width="10%" sortable>
                <template slot-scope="{ row }">
                    <a v-if="row.efoCode && row.efoCode.indexOf('EFO:') == 0" :href="'http://www.ebi.ac.uk/efo/' + row.efoCode.replaceAll(':', '_')" target="_blank">{{ row.efoOntologyTrait }}</a>
                    <a v-if="row.efoCode && row.efoCode.indexOf('EFO:') != 0" :href="'http://purl.obolibrary.org/obo/' + row.efoCode.replaceAll(':', '_')" target="_blank">{{ row.efoOntologyTrait }}</a>
                </template>
            </t-table-column>
            <t-table-column label="Trait Ontology ID" property="efoCode" width="6%" sortable>
                <template slot-scope="{ row }">
                    <a v-if="row.efoCode && row.efoCode.indexOf('EFO:') == 0" :href="'http://www.ebi.ac.uk/efo/' + row.efoCode.replaceAll(':', '_')" target="_blank">{{ row.efoCode }}</a>
                    <a v-if="row.efoCode && row.efoCode.indexOf('EFO:') != 0" :href="'http://purl.obolibrary.org/obo/' + row.efoCode.replaceAll(':', '_')" target="_blank">{{ row.efoCode }}</a>
                </template>
            </t-table-column>
            <t-table-column label="P-Value" property="pvalue" width="6%" sortable />
            <t-table-column label="Method" property="method" width="6%" sortable />
        </t-table>
    </div>
</template>

<script>
import table_mix from "@/common/table_mix";
export default {
    name: "genedetail_trait",

    mixins: [table_mix],

    props: {
        detailId: String,
    },

    data() {
        return {};
    },

    created() {
        this.refreshTable();
    },

    computed: {
        getTableDataAjaxUrl() {
            return `gene/${this.detailId}/association/page`;
        },
    },

    methods: {
        download() {
            window.open(`/api/gene/${this.detailId}/association/export?keyword=${this.queryTableParams.keyword}`, '_blank')
        },
    },
};
</script>

<style scoped></style>
